module.exports = __webpack_public_path__ + "img/christian-today.ed555c0d.svg";